import React, { Component } from "react";
import View from "./view";
import "./index.css";
import { getUser, getToken } from "../../backend/storage";
import { getMachine, searchTool } from "../../backend/machine";
import { assignMachine, getRequestList } from "../../backend/machine";

class MachineScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToLogin: false,
      code: props.match.params.barcode || "",
      showDialog: false,
      receiveSuccess: false,
      toolRequestClick: false,
      loading: false,
      machine: { id: ""},
      tool : { id: "", code:""},
      errMsg: "",
      machine_model_id: "",
      request_list:[],
      courier_number: "",
      courier_number2: "",
      branchRecordId: "",
      machine_model : [], // store 허용 machine
      storeId : "", 
      storeName : "",
      toolId: "",
      toolCode: "",
      bag_id : "",
      checkModelPop: false,
      checkModelPopMsg:"",
      checkModelContinue : false,
    };

    this._assignMachine = this._assignMachine.bind(this);
    this._getMachine = this._getMachine.bind(this);
    this._checkMachineStatus = this._checkMachineStatus.bind(this);
    this._renderRequestListMain = this._renderRequestListMain.bind(this);
    this._renderRequestListMainTool = this._renderRequestListMainTool.bind(this);
    this._checkMachineSelected = this._checkMachineSelected.bind(this);
    this._searchTool = this._searchTool.bind(this)
;  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.match.params.barcode !== this.props.match.params.barcode) {
  //     this._getMachine(this.state.code);
  //   }
  // }

  async _assignMachine() {
    this.setState({ loading: true });
    assignMachine(this.state.machine.id);
    this.setState({ receiveSuccess: true, loading: false });
  }
 
  async componentDidMount() {
    if (!(await getUser()) || !(await getToken())) {
      this.setState({ redirectToLogin: true });
    }

    if (this.state.code !== "") {
      this._getMachine(this.state.code);
    }

    // get Request List
    let request_list_response = await getRequestList('Machine');
    this.setState({request_list : request_list_response})
  }

  async _getMachine() {
    const { history } = this.props;
    this.setState({ loading: true, errMsg: "" });
    let machine;
    try {
      machine = await getMachine(this.state.code);
      if (machine.success === 1) {
        this.setState({ 
          machine: machine.data, 
          loading: false,
          machine_model_id : machine.data.model_id
        });
      } else {
        this.setState({
          machine: { id: "" },
          loading: false,
          errMsg: machine.data
        });
      }
    } catch (error) {
      if (error.message === "token_not_provided") return history.push("/login");
      machine = { id: "" };
    }
  }
  async _searchTool(code) {

    let { data } = (await searchTool(this.state.toolCode)).data;
    return data.map(tool => ({ value: tool.id, label: tool.code, bag_id : tool.bag_id}));
    
  }

  render() {
    return View.call(this);
  }
  // Only Available status machine can be sent
  _checkMachineStatus(){
    let status = this.state.machine.hire_status
    if(status !== 'Available'){
      this.setState({errMsg : "This machine cannot be sent to the store. Please check a machine status."})
    }else{
      // redirect to the form
      this.props.history.push({
        pathname: `/machine/${this.state.machine.id}/send`
      })
    }
  }
  _renderRequestListMain( item, key ){
    return ( item.type !== 'Tool' && 
      <a className="request_list_item" key={key} data-id={item.id} onClick={ () =>{

        this.setState({
          courier_number: item.courier_number,
          courier_number2 : item.courier_number2,
          branchRecordId: item.id,
          storeId : item.store.id,
          storeName : item.store.name,
          machine_model : item.store.machine_model
        },() =>{
          // let check = this._checkMachineSelected()
        })
        
      }

      }>
        <strong>{item.store.name}</strong>
        <div className="flex_wrap">
          <div>
            Outgoing : <b>{item.courier_number}</b><br />
            Incoming : <b>{item.courier_number2}</b>
          </div>
          <div className="mm_wrap">
            {(item.store.machine_model).map((item, index) => this._renderMachineModelMain(item,index))}
          </div>
        </div>
      </a>
    )
  }
  _renderRequestListMainTool( item, key ){
    return ( item.type === 'Tool' && 
      <a className="request_list_item" key={key} data-id={item.id} onClick={ () =>{
        this.setState({
          courier_number: item.courier_number,
          courier_number2 : item.courier_number2,
          branchRecordId: item.id,
          storeId : item.store.id,
          storeName : item.store.name,
        },() =>{
          // tool search popup 띄워야 함.
          this.setState({
            toolRequestClick: true,
          })

        })
        
      }

      }>
        <strong>{item.store.name}</strong>
        <div className="flex_wrap">
          <div>
            Outgoing : <b>{item.courier_number}</b><br />
            Incoming : <b>{item.courier_number2}</b>
          </div>
        </div>
      </a>
    )
  }
  _renderMachineModelMain( item, key ){
    return (
      <span className="mm" key={key} style={{backgroundColor: `#`+item.color}} data-id={item.id}>{item.name}</span>
    )
  }
  async _checkMachineSelected(){
    let machineSelected = this.state.machine.id

    if (machineSelected === '') {
      this.setState({errMsg : "Please enter or scan the serial number"})
    }else{// machine selected 

      // check machine_model and store machine model
      if (this.state.machine_model.length !== 0){
        // compart with store allowable machine code
        let checkModel = 0;
        for(let i=0; i < this.state.machine_model.length; i++){
          if(this.state.machine_model[i].id === this.state.machine_model_id) checkModel++;
        }
        if(checkModel === 0){ 
          if( !this.state.checkModelContinue ){
            return this.setState({checkModelPop : true, checkModelPopMsg : "This machine cannot be sent to this store. \nDo you want to continue sending this machine?"});
          }
        }
      }

      // Redirect to the sending form with state
      let state = {
        machineId: this.state.machine.id,
        machine_model_id: this.state.machine_model_id,
        request_list:this.state.request_list,
        courier_number: this.state.courier_number,
        courier_number2: this.state.courier_number2,
        branchRecordId: this.state.branchRecordId,
        machine_model : this.state.machine_model, // store 허용 machine
        storeId : this.state.storeId, 
        storeName : this.state.storeName,
      }
      let c2 = this.state.courier_number2 !== null ? `/${this.state.courier_number2}` : '';
      let url = `/machine/${this.state.machine.id}/send/${this.state.courier_number}`+c2;
      this.props.history.push({
        pathname: url,
        state: state
      })
    }
  }
}

export default MachineScreen;


// WEBPACK FOOTER //
// ./src/screens/machine/index.js